const firebaseConfig = {
  apiKey: 'AIzaSyDCtEcBDlHxsEjr-KMhGvL4BeCdzBXCCkI',
  authDomain: 'nitch193-portfolio.firebaseapp.com',
  projectId: 'nitch193-portfolio',
  storageBucket: 'nitch193-portfolio.appspot.com',
  messagingSenderId: '413582379160',
  appId: '1:413582379160:web:683454d27f3c8f984028ed',
  measurementId: 'G-KM703FKFQR',
};
export default firebaseConfig;
